import $ from 'sbf-design-system/js/jquery';

const BraintreeHostedFields = {
  instance: null,

  create: (clientInstance) => {
    window.braintree.hostedFields.create({
      client: clientInstance,
      styles: {
        input: {
          'font-size': '1em',
          'font-weight': '400',
          'font-family': '\'Helvetica Neue\', Arial',
          '-webkit-font-smoothing': 'antialiased',
          color: '#353535'
        },
        select: {
          appearance: 'none',
          'font-size': '1em',
          'font-weight': '400',
          'font-family': '\'Helvetica Neue\', Arial',
          '-webkit-font-smoothing': 'antialiased',
          color: '#353535'
        },
        'input.invalid::-webkit-input-placeholder': {
          color: '#CD2617'
        },
        'select.invalid': {
          color: '#CD2617'
        }
      },
      fields: {
        number: {
          selector: '#number',
          placeholder: 'Card Number *',
        },
        cardholderName: {
          selector: '#cardholderName',
          placeholder: 'Name on Card *',
        },
        expirationMonth: {
          selector: '#expirationMonth',
          placeholder: 'MM *',
          select: {
            options: [
              '01', '02', '03', '04', '05', '06',
              '07', '08', '09', '10', '11', '12',
            ],
          },
        },
        expirationYear: {
          selector: '#expirationYear',
          placeholder: 'YYYY *',
          select: true,
        },
        cvv: {
          selector: '#cvv',
          placeholder: 'CVV *',
        },
      },
    }, (err, instance) => {
      if (err) {
        console.error(err);
        return;
      }

      BraintreeHostedFields.instance = instance;

      BraintreeHostedFields.instance.on('notEmpty', (event) => {
        const container = $(event.fields[event.emittedBy].container);
        container.removeClass('invalid');
        BraintreeHostedFields.instance.removeClass(event.emittedBy, 'invalid');
      });
    });
  },

  validate: () => {
    const state = BraintreeHostedFields.instance.getState();
    let allFieldsValid = true;

    for (const key in state.fields) {
      if (Object.prototype.hasOwnProperty.call(state.fields, key)) {
        const field = state.fields[key];

        if (!field.isValid) {
          const container = $(field.container);
          container.addClass('invalid');
          BraintreeHostedFields.instance.addClass(key, 'invalid');
          allFieldsValid = false;
        }
      }
    }

    return allFieldsValid;
  },

  getFirstInvalidField: () => {
    const state = BraintreeHostedFields.instance.getState();

    for (const key of Object.keys(state.fields)) {
      if (!state.fields[key].isValid) {
        return key;
      }
    }

    return false;
  },

  clearFields: () => {
    const state = BraintreeHostedFields.instance.getState();

    for (const key of Object.keys(state.fields)) {
      BraintreeHostedFields.instance.clear(key);
    }
  }
};

export default BraintreeHostedFields;